/**
 * @fileoverview POST handler for the "/apps/:app_group_id/custom_events_settings_create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCustomEventsSettingsCreateCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdCustomEventsSettingsCreateProps,
  AppsAppGroupIdCustomEventsSettingsCreateResult,
} from "./types";

export const postAppsAppGroupIdCustomEventsSettingsCreate = reactQueryMutationAdapter(
  appsAppGroupIdCustomEventsSettingsCreateCacheKeys,
  (
    props: PostAppsAppGroupIdCustomEventsSettingsCreateProps
  ): Promise<AppsAppGroupIdCustomEventsSettingsCreateResult> => {
    return fetch(`/apps/${props.appGroupId}/custom_events_settings_create`, "POST", props);
  }
);
